import { createQueryKey } from '../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../query/types';
import { causeSelectionKeys } from './causeSelections/keys';
import { roleKeys } from './causes/roles/keys';
import { quickbooksKeys } from './credentials/quickbooks/keys';
import { paymentMethodsKeys } from './paymentMethodsV2/paymentMethods.keys';
import { stripeKeys } from './stripe/keys';

const coreIdKey = <T extends QueryKey, U extends QueryKeyParam>(keys: T, scopeId: U) =>
  createQueryKey({
    all: [...keys, scopeId] as const,
    access: [...keys, scopeId, 'access'] as const,
    detail: [...keys, scopeId, 'detail'] as const,
    stripe: stripeKeys([...keys, scopeId] as const),
    quickbooks: quickbooksKeys([...keys, scopeId] as const),
    roles: roleKeys([...keys, scopeId] as const),
  });

const coreUserKey = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'user'] as const,
    causeSelection: causeSelectionKeys([...keys] as const),
    paymentMethods: paymentMethodsKeys([...keys, 'paymentMethods', 'v2'] as const),
  });

const coreKeys = createQueryKey({
  all: ['core'] as const,
  id: <T extends QueryKeyParam>(id: T) => coreIdKey(['core'] as const, id),
  user: coreUserKey(['core'] as const),
});

export { coreKeys };
